import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { UrlConstants } from "../../../../../shared/constants/url.constants";
export class ViewApplicationPremisesEhmsConstants {
    static STEP_TITLE = "Premises";
    static ZONE_LABEL = "Current property zone";
    static ADD_ZONE_LABEL = "Add Premises";
    static OWNER_LABEL = "Owners";
    static CONTACTS_LABEL = "Contacts";
    static REMOVE_PROPERTY_LABEL = "Remove Premises";
    static COPY_APPLICANT_TO_OWNER_LABEL = "Copy applicant to owner";
    static COPY_APPLICANT_TO_CONTACTS_LABEL = "Copy applicant to contacts";
    static COPY_OWNER_TO_CONTACTS_LABEL = "Copy owner to contacts";
    static DESCRIPTION_LABEL_1 = "Search the map to find the premises for which you are lodging an application, using the 'Find address or place' search bar.";
    static DESCRIPTION_LABEL_2 = "Zoom in close enough to the correct location on the map. Click on the 'Draw' toolbar button and select the 'Draw a point' tool. Place the point selector at the correct location on the map.";
    static DESCRIPTION_LABEL_3 = "The premises will be added to the application and all the required fields must be completed for the premises. Multiple premises may be added.";
    static DESCRIPTION_LABEL_4 = "Please note that one or more owners and/or contacts should be added for each premises (the owners and/or contacts will be linked to the premises and the application)";
    static NAME_CONTROL = "name";
    static ADDRESS_CONTROL = "address";
    static POSTAL_ADDRESS_CONTROL = "postalAddress";
    static TELEPHONE_CONTROL = "telephone";
    static EMAIL_CONTROL = "email";
    static FAX_CONTROL = "fax";
    static CELLPHONE_CONTROL = "cellphone";
    static GEOMETRY_CONTROL = "geometry";
    static PREMISES_TYPE_CONTROL = "premiseType";
    static OWNER_CONTROL = "owners";
    static CONTACTS_CONTROL = "contacts";
    static NAME_TEXT_PLACEHOLDER = "Name";
    static ADDRESS_TEXT_PLACEHOLDER = "Address";
    static POSTAL_ADDRESS_TEXT_PLACEHOLDER = "Postal address";
    static TELEPHONE_TEXT_PLACEHOLDER = "Telephone number";
    static EMAIL_TEXT_PLACEHOLDER = "Email";
    static FAX_TEXT_PLACEHOLDER = "Fax";
    static CELLPHONE_TEXT_PLACEHOLDER = "Cellphone number";
    static GEOMETRY_TEXT_PLACEHOLDER = "Geometry";
    static PREMISES_TYPE_TEXT_PLACEHOLDER = "Premises type";
    static OWNER_TEXT_PLACEHOLDER = "Ownerd";
    static CONTACTS_TEXT_PLACEHOLDER = "Contacts";
    static PREMISES_URL = UrlConstants.API_V2 + "EhPremise";
    static DUPLICATE_MESSAGE = "The selected premises has already been added";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static MISSING_OWNER_IN_PROPERTY = "Please add at least one owner in all properties";
    static INVALID_OWNER_ATTRIBUTE = "Some owner attribute(s) is missing on the property owner layer. Please contact your systems administrator.";
    static INVALID_CONTACT_ATTRIBUTE = "Some contact attribute(s) is missing on the property contact layer. Please contact your systems administrator.";
    static INVALID_ZONING_ATTRIBUTE = "Zoning attribute is missing on the property zoning layer. Please contact your systems administrator.";
    static ZONING_NOT_FOUND = "The found zone ({0}) has not been configured in the lookups. Please contact your systems administrator.";
    static VALIDATION_MESSAGES = {
        name: {
            required: `Name ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        address: {
            required: `Address ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        postalAddress: {
            required: `Postal Address ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        telephone: {
            required: SharedConstants.PHONE_NUMBER_VALIDATION_MESSAGE
        },
        email: {
            required: SharedConstants.EMAIL_VALIDATION_MESSAGE
        },
        fax: {
            required: SharedConstants.PHONE_NUMBER_VALIDATION_MESSAGE
        },
        cellphone: {
            required: SharedConstants.PHONE_NUMBER_VALIDATION_MESSAGE
        },
        geometry: {
            required: `Geometry ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        premisesType: {
            required: `Premises type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        owner: {
            required: `Owner ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        contacts: {
            required: `Contacts ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
}
